import React, { useContext, useState } from "react";
import { PatientContext, ThemeContext } from "../../lib/main-context";
import { useTranslation } from "../../i18n/TranslationProvider";

import { Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import inviteTPSchema from "./validations/inviteTPSchema";

import theme from "../../index.scss";
import LabelledInput from "../UIComponents/LabelledInput";
import SubmitButton from "../UIComponents/SubmitButton";

import {
  sendTherapistEmailFromProvider,
  sendTherapistEmailFromPatient,
  sendTherapistEmailFromCg,
  sendConnectExistingTherapistEmail,
  checkTherapistEmailExisting,
} from "../../api/helpReq";

const InviteTherapist = ({ user }) => {
  const { t } = useTranslation();
  const { patient } = useContext(PatientContext);
  const { dark } = useContext(ThemeContext);

  const [inputVisible, setInputVisible] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [message, setMessage] = useState("");

  const { register, handleSubmit, errors, setError } = useForm({
    resolver: yupResolver(inviteTPSchema),
  });
  const onSubmit = (data) => {
    setSubmitDisabled(true);

    data.therapistEmail = data.therapistEmail.toLowerCase();

    checkTherapistEmailExisting({ data, userType: user.userType })
      .then((res) => {
        if (res.data.exist == "false") {
          if (user.userType == "provider") {
            sendTherapistEmailFromProvider({ data })
              .then(() => {
                setMessage(t("invitetherapist.messages.sent"));
                setInputVisible(false);
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                setSubmitDisabled(false);
              });
          } else if (user.userType == "caregiver") {
            sendTherapistEmailFromCg({ data, patientId: patient.patientId })
              .then(() => {
                setMessage(t("invitetherapist.messages.sent"));
                setInputVisible(false);
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                setSubmitDisabled(false);
              });
          } else {
            // patient
            sendTherapistEmailFromPatient({
              data,
              patientId: patient.patientId,
            })
              .then(() => {
                setMessage(t("invitetherapist.messages.sent"));
                setInputVisible(false);
              })
              .catch((error) => {
                console.error("Error:", error);
              })
              .finally(() => {
                setSubmitDisabled(false);
              });
          }
        } else if (res.data.exist == "true") {
          sendConnectExistingTherapistEmail({
            data,
            userType: user.userType,
            patientId: patient.patientId,
          })
            .then(() => {
              setMessage(t("invitetherapist.messages.sent"));
              setInputVisible(false);
            })
            .catch((e) => {
              if (e.response.status === 409) {
                setMessage(t("invitetherapist.messages.refer_patient"));
              }
            })
            .finally(() => {
              setSubmitDisabled(false);
            });
        } else if (res.data.exist == "connectionExisting") {
          setSubmitDisabled(false);
          setMessage(t("invitetherapist.messages.existing_connection"));
        } else if (res.data.exist == "existingOtherTypeAccount") {
          setSubmitDisabled(false);
          setMessage(t("invitetherapist.messages.other_account_type"));
        }
      })
      .catch((e) => {
        console.error("Error checkTherapistEmailEmailExisting");
      });
  };

  return (
    <>
      <div className="d-flex justify-content-center">
        <h6
          className="pt-2 pb-2"
          style={{
            width: "75%",
            borderRadius: "20px",
            backgroundColor: dark ? theme.darkModePrimary : "#f7bc12",
            color: dark ? theme.darkModeText : "white",
            textAlign: "center",
            overflowWrap: "break-word",
            cursor: "pointer",
          }}
          onClick={() => setInputVisible(!inputVisible)}
        >
          {t("invitetherapist.header.0")}
          <br />
          {t("invitetherapist.header.1")}
        </h6>
      </div>
      {inputVisible && (
        <Row className="p-2">
          <Col>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row className="p-2">
                <Col>
                  <LabelledInput
                    required
                    label={t("invitetherapist.therapist_email")}
                    name="therapistEmail"
                    type="email"
                    errors={errors}
                    inputRef={register}
                  />
                  <SubmitButton type="submit" disabled={submitDisabled}>
                    {t("invitetherapist.button")}
                  </SubmitButton>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      )}
      {message && (
        <Row className="p-2">
          <Col className="text-center">{message}</Col>
        </Row>
      )}
    </>
  );
};

export default InviteTherapist;